import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';

import { ApplicationUser } from '../../security/application-user.model';
import { UserAuthorizationService } from '../../security/services/user-authorization.service';
import { SharedToasterService } from '../../shared/services/shared-toaster.service';
import { SportTrainerContactModel } from '../../sports/models/sport-trainer-contact.model';
import { SportService } from '../../sports/services/sports.service';
import { KnowHowMessageTrainerPostModel } from '../models/know-how-message-trainer-post.model';

@Component({
    selector: 'app-know-how-message-modal',
    templateUrl: './know-how-message-modal.component.html',
    styleUrl: './know-how-message-modal.component.scss'
})
export class KnowHowMessageModalComponent implements OnInit {

    @Input({ required: true }) sportId!: number;
    @Input({ required: true }) trainerAdmins!: SportTrainerContactModel[];
    @Input({ required: true }) trainerContacts!: SportTrainerContactModel[];

    isLoading: boolean = false;
    messageForm!: FormGroup;

    constructor(
        protected sportService: SportService,
        private formBuilder: FormBuilder,
        private bsModalRef: BsModalRef,
        private authService: UserAuthorizationService,
        private toasterService: SharedToasterService
    ) { }

    ngOnInit(): void {
        this.initForm();
    }

    get sender(): ApplicationUser | null {
        let sender = this.authService.user;
        return sender ?? null;
    }

    protected onSubmit(): void {
        if (this.isLoading) return;
        if (!this.messageForm.valid) return;
        this.isLoading = true;

        var trainerIds = this.trainerContacts.flat().map(x => x.id);
        var adminIds = this.trainerAdmins.flat().map(x => x.id);

        const postModel: KnowHowMessageTrainerPostModel = {
            selectedTrainerIds: trainerIds,
            selectedAdminIds: adminIds,
            message: this.messageForm.get('trainerMessage')?.value,
            subject: this.messageForm.get('subject')?.value,
            sportId: this.sportId,
        }

        this.sendMessage(postModel);
    }

    private initForm(): void {
        this.messageForm = this.formBuilder.group({
            trainerMessage: ["", Validators.required],
            subject: ["", Validators.required]
        })
    }

    private sendMessage(postData: KnowHowMessageTrainerPostModel): void {
        this.sportService.sendMessageToTrainers(postData).subscribe({
            next: (response) => {
                this.toasterService.showGeneralEmailSendingSuccess();
                this.bsModalRef.hide();
            },
            error: (error) => {
                this.toasterService.showGeneralEmailSendingError();
                this.isLoading = false;
            }
        });
    }
}
